import { useListingContext } from '@/microfrontends/listing/shared/context/ListingContext';

import { memoWithDisplayName } from '@/packages/react-utils/memoWithDisplayName';
import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';

import { QuickLinksInlineList } from './components/QuickLinksInlineList';
import { QuickLinksLayout } from './components/QuickLinksLayout';
import { QuickLinksList } from './components/QuickLinksList';
import { trackQuickLinkClick } from './tracking';

export const QuickLinksContainer = memoWithDisplayName(() => {
  const {
    seo: {
      view: { links },
    },
  } = useListingContext();

  const isNarrow = useListingLayoutIsNarrowSelector();

  if (!links.length) {
    return null;
  }

  const QuickLinksComponent = isNarrow ? QuickLinksInlineList : QuickLinksList;

  return (
    <QuickLinksLayout isNarrow={isNarrow}>
      <QuickLinksComponent quickLinks={links} trackQuickLinkClick={trackQuickLinkClick} />
    </QuickLinksLayout>
  );
}, 'QuickLinksContainer');
